$(document).ready(function (){
    $("#table-books tbody").on('click','.add-review-book',function (){
        let slug = $(this).data('slug')
        $("#text-modal-review").html('Agregar reseña')
        $(".item-action-review").val('add')
        $(".item-slug-review").val(slug)
        $("#modal-reviews").modal('show')
        clearInput()
        getReviewsForBook(slug)
    })

    $(document).on('click', '.edit-review', function (e) {
        e.preventDefault()
        let index = $(this).data('index')
        let data = $(this).data('data')
        $(".item-action-review").val('edit')
        $.each(data, function (index, value) {
            if (index == "id") {
                $(".item-review_id").val(value)
            }
            $(".item-" + index).val(value)
        })
        scrollAlInicio()
    })

    $(document).on('click', '.delete-review', function (e){
        e.preventDefault()
        let review_id = $(this).data('identificador')
        let book_id = $(this).data('book_id')
        let slug = $(".item-slug-review")
        let data = new FormData()
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                data.append('review_id', review_id)
                data.append('book_id', book_id)
                clearInput()
                sendData("/admin/books/delete-review",data)
            }
        })

    })


    $("#form-review").on('submit', function (e){
        e.preventDefault()
        let data = new FormData(this)
        let action = $(".item-action-review").val()
        clearInput()
        sendData("/admin/books/"+ action +"-review",data)
    })

    function sendData(route,data) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    document.getElementById('div_reviews_books').innerHTML = response.view;
                }, 1000)
                alertSuccess(response.msg)
                clearInput()
            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }

    function getReviewsForBook(slug)
    {
        $.ajax({
            url: "/admin/get-reviews-by-slug/" + slug, type: "get", processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                document.getElementById('div_reviews_books').innerHTML = response;
            }
        })
    }

    function scrollAlInicio() {
        $(".item-review").addClass('input-textarea-intermitente')
        $(".item-middle").addClass('input-textarea-intermitente')
        $(".item-url").addClass('input-textarea-intermitente')
        setTimeout(function () {
            $(".item-review").removeClass('input-textarea-intermitente')
            $(".item-middle").removeClass('input-textarea-intermitente')
            $(".item-url").removeClass('input-textarea-intermitente')
        }, 4000)
        let myModal = document.getElementById("modal-reviews");
        myModal.scrollTop = 0;
    }

    function clearInput() {
        $(".item-action-review").val('add')
        $(".item-review_id").val('')
        $(".item-review").val('')
        $(".item-middle").val('')
        $(".item-url").val('')
    }

    function clearSpan() {
        $(".item-review").removeClass('is-invalid')
        $(".item-middle").removeClass('is-invalid')
        $(".item-url").removeClass('is-invalid')
        $(".item-error-review").html('');
        $(".item-error-middle").html('');
        $(".item-error-url").html('');
    }
})
